import React from 'react';
import Flickity from 'react-flickity-component';

class ImageSlider extends React.Component {
  componentDidMount = () => {
    this.flkty.on('ready', () => {
      // this.setState({
      //   totalSlides: this.flkty.cells.length
      // });
      // console.log(this.flkty);
    });
    this.flkty.on('change', () => {
      // this.setState({
      //   currentSlide: this.flkty.selectedIndex + 1
      // });
    })
  }

  render() {
    const flickityOptions = {
      initialIndex: 0,
      pageDots: false,
      wrapAround: true,
      bgLazyLoad: 2,
      autoPlay: 4000,
      cellSelector: '.carousel-cell',
      draggable: true,
      // freeScroll: true,
    }
    const slides = this.props.slides;

    return (
      <div className="image-slider">
        <div className="flickity-cnt" rel="flickity_cnt">
          <Flickity flickityRef={c => this.flkty = c}
                    className={'carousel'} // default ''
                    elementType={'div'} // default 'div'
                    options={flickityOptions} // takes flickity options {}
                    disableImagesLoaded={false} // default false
                     >
            {slides.map((slide, i) => {
              return <div key={i} className="slide carousel-cell" style={{backgroundImage:'url(' + slide.slide.url + ')'}} />
            })}
          </Flickity>
        </div>
      </div>
    );
  }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/scripts/components/image-slider.js